import React from 'react';
import FormItem from '../../../common/form/FormItem';
import FormWidget from '../../../common/form/FormWidget';
import ScheduleWidget from '../../../common/form/widgets/ScheduleWidget';
import I18n from '../../../common/i18n/I18n';
import { FormContainer } from '../../../common/form/FormContainer';

export default ({
    hasLinkedActivities,
    hideSectionTitle = false
}: {
    hasLinkedActivities?: boolean;
    hideSectionTitle?: boolean;
}) => {
    return (
        <FormContainer
            titleI18nToken={`${hasLinkedActivities ? 'form.resource.activity.dependent.schedule' : 'form.resource.schedule'}`}
            hideTitle={hideSectionTitle}
        >
            <FormItem>
                <FormWidget
                    component={'Switch'}
                    disabled={hasLinkedActivities}
                    name="resourceSchedule.dateRange.durationSpecified"
                    label={<I18n token="resource.form.specify.duration.label" />}
                    hideHelperText
                />
            </FormItem>
            <ScheduleWidget
                showFullSchedule
                name="resourceSchedule.dateRange"
                allowedUnits={['hour', 'day', 'week']}
                disabled={hasLinkedActivities}
            />
        </FormContainer>
    );
};
